import { formatInTimeZone } from 'date-fns-tz';
import { useCalendarPreferences } from './calendarPreferences';
import { displayBookingDate } from './bookingCalendarLabel';
import { formatClockText } from './clockSystem';
export function formatDisplayDate(value, calendar, timezone = Intl.DateTimeFormat().resolvedOptions().timeZone) {
  if (!value) return '';
  try {
  const civil = /^\d{4}-\d{2}-\d{2}$/.test(String(value)) ? String(value) : formatInTimeZone(new Date(/^\d+$/.test(String(value)) ? Number(value) : value), timezone, 'yyyy-MM-dd');
  return displayBookingDate(civil, calendar);
  } catch { return 'Invalid date'; }
}
export function formatDisplayDateTime(value, calendar, clock, timezone = Intl.DateTimeFormat().resolvedOptions().timeZone) {
  if (!value) return '';
  try {
    const date = new Date(/^\d+$/.test(String(value)) ? Number(value) : value);
    return `${formatDisplayDate(date, calendar, timezone)} at ${formatClockText(formatInTimeZone(date, timezone, 'h:mm a'), clock)} (${timezone})`;
  } catch { return 'Invalid date'; }
}
export function useDateTimeDisplay() {
  const prefs = useCalendarPreferences();
  return { ...prefs,
    dateLabel: (value, timezone = prefs.timezone) => formatDisplayDate(value, prefs.displayCalendar, timezone),
    clockLabel: value => formatClockText(value, prefs.displayClock),
    dateTimeLabel: (value, timezone = prefs.timezone) => formatDisplayDateTime(value, prefs.displayCalendar, prefs.displayClock, timezone),
  };
}
